import { SelectionChangedEvent } from "ag-grid-community";
import { EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA } from "domain/entity/StandardProposal/StandardProposalSearchCriteria";
import moment from "moment";
import { INITIAL_STANDARD_PROPOSAL_COL_DEF, transferRowData } from "presentation/constant/StandardProposal/StandardProposalColumnDefinition";
import { StandardProposalConstant } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useStandardProposalVM } from "presentation/hook/StandardProposal/useStandardProposalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Core } from "veronica-ui-component";
import { GroupButtons, Loader } from "veronica-ui-component/dist/component/core";


const StandardProposalTablePanel: React.FC = () => {
    const [standardProposalState] = useStandardProposalTracked();
    const standardProposalVM = useStandardProposalVM();
    const gridRef: any = useRef(null);
    const [isLoading] = useState<boolean>(false);
    const { searchStatus, standardProposalList, isRejected, isRejectedCount, isPendingApproval, isPendingApprovalCount, isShowTariffItemPanel } = standardProposalState;
    const STANDARD_PROPOSAL_CONSTANT = StandardProposalConstant.Table;
    const messageBarVM = useMessageBarVM();
    /*const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(standardProposalState.isSearchLoading || (!standardProposalState.isSearchLoading &&
            standardProposalList && standardProposalList.length) ? false : true);

        if (gridRef.current?.gridRef.current && !standardProposalState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [standardProposalState.isSearchLoading, standardProposalList]);*/

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        standardProposalVM.updateSelectedRows(selectedRows);
    }, [standardProposalVM])

    const handleGroupButtonClick = useCallback(async (buttonId: string) => {
        standardProposalVM.onShowLoading();
        standardProposalVM.setIsSearchLoading(true);
        if (searchStatus && buttonId === searchStatus) {
            let newSearchCriteria = null;
            newSearchCriteria = { ...EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                effectiveDateFrom: moment().subtract(2, "years").startOf("year").toDate(),
                effectiveDateTo: moment().endOf('year').endOf('day').toDate(),
            };
            await standardProposalVM.searchAllStandardProposal();
            await standardProposalVM.searchStandardProposal(newSearchCriteria).then((data) => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            }).catch(error => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            }).finally(() => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            })
        } else {
            await standardProposalVM.onGroupButtonClick(buttonId).then((data) => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            }).catch(error => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            }).finally(() => {
                standardProposalVM.onHideLoading();
                standardProposalVM.setIsSearchLoading(false);
            })
        }

    }, [searchStatus, standardProposalVM]);

    const template = useMemo(() => {
        return (
            <>
                {/* <Core.CheckButton
            checked={isAll}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
            showBadge={true}
            badgeValue={isAllCount>999?'999+':isAllCount}
            disabled={isAllCount===0}
            size="medium"
            inputId="isAll"
            label={STANDARD_PROPOSAL_CONSTANT.ALL_BUT} 
          /> */}
                <Core.CheckButton
                    checked={isRejected}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isRejectedCount > 999 ? '999+' : isRejectedCount}
                    disabled={isRejectedCount === 0}
                    size="medium"
                    inputId="isRejected"
                    label={STANDARD_PROPOSAL_CONSTANT.REJECTED_BUT}
                />
                <Core.CheckButton
                    checked={isPendingApproval}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isPendingApprovalCount > 999 ? '999+' : isPendingApprovalCount}
                    disabled={isPendingApprovalCount === 0}
                    size="medium"
                    inputId="isPendingApproval"
                    label={STANDARD_PROPOSAL_CONSTANT.PENDING_APPROVAL_BUT}
                />
            </>
        )
    }, [STANDARD_PROPOSAL_CONSTANT.PENDING_APPROVAL_BUT, STANDARD_PROPOSAL_CONSTANT.REJECTED_BUT, handleGroupButtonClick, isPendingApproval, isPendingApprovalCount, isRejected, isRejectedCount])

    const isRowSelectable = useCallback((params: any) => {
        return !isShowTariffItemPanel;
    }, [isShowTariffItemPanel]);

    const memoStandardProposalTable = useMemo(() => {

        return (
            <NbisTable
                id='standard-proposal-table'
                isNewColumnSetting={true}
                columns={INITIAL_STANDARD_PROPOSAL_COL_DEF?.slice()}
                data={transferRowData(standardProposalList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                // onRowClick={(e: any) => handleRowClick(e.data)}
                // onRowDoubleClick={(e: any, entity: StandardProposalEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 145px)"
                ref={gridRef}
                headerLabel={
                    <GroupButtons
                        alignment="single-selection"
                        errorMessage=""
                        label=""
                        children={template}
                    />
                }
                messageVM={messageBarVM}
                handleRowSelectable={isRowSelectable}
                //showDefaultOverlayNoRowsTemplate={showOverlay}
                isLoading={standardProposalState.isSearchLoading}
            />
        );
    }, [standardProposalList, handleSelectionChange, template, messageBarVM, isRowSelectable, standardProposalState.isSearchLoading])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowTariffItemPanel, standardProposalState.isAddTariffItem, standardProposalState.isEditStdProposal])

    return <><TableWrapper>
        {(standardProposalState.isLoading || isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoStandardProposalTable}
    </TableWrapper>
    </>;
}

export default memo(StandardProposalTablePanel);
